export default __webpack_public_path__ + "static/media/health.09f06043.jpg";